export default __webpack_public_path__ + "static/media/32.e79d7592.svg";